import $ from 'jquery';

$(function() {

    $(window).on('form-modal:opened ajaxForm:success', function(){
        $('.courses-plugin__form__additional_attendees__formset').formset({
            prefix: 'attendee',
            deleteText: window.coursesFormsetTranslations.deleteText,
            deleteCssClass: 'courses-plugin__form__additional_attendees__btn-delete',
            addText: 'Person hinzufügen',  // yes, it's not translated. In Django 1.9 this is kind of a hustle :/
            addCssClass: 'courses-plugin__form__additional_attendees__add-attendee',
            removed: function(row) {
                // remove dom node of additional attendee to prevent it being sent to django form (display: none; doesn't help here obviously)
                row.remove();
                if ($('.courses-plugin__form__additional_attendees__formset').length === 0) {
                    // if all additional attendees have been delete set TOTAL_FORMS to zero (for backend validation)
                    $('#id_attendee-TOTAL_FORMS').val(0);
                }
            }
        });
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/courses-registration.js